import { createContext, useContext, useState, useEffect, useCallback } from "react";

const I18nContext = createContext(null);

const DICT = {
  fr: {
    dashboard: "Tableau de bord",
    crm: "CRM Social",
    contacts: "Contacts & Leads",
    pipeline: "Pipeline",
    segments: "Segments",
    accounts: "Comptes & Instagram",
    strategy: "Stratégie & Contenu",
    analytics: "Analytics & Performance",
    operations: "Opérations",
    growth: "Croissance",
    algorithms: "Algorithmes & Stratégie",
    team: "Équipe & Agence",
    settings: "Paramètres",
    hello: "Bonjour",
    quickActions: "Actions rapides",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    add: "Ajouter",
    search: "Rechercher",
    notifications: "Notifications",
    profile: "Profil",
    logout: "Déconnexion",
    appearance: "Apparence",
    language: "Langue",
    integrations: "Intégrations",
    account: "Compte & Workspace",
  },
  en: {
    dashboard: "Dashboard", crm: "Social CRM", contacts: "Contacts & Leads",
    pipeline: "Pipeline", segments: "Segments", accounts: "Accounts & Instagram",
    strategy: "Strategy & Content", analytics: "Analytics & Performance",
    operations: "Operations", growth: "Growth", algorithms: "Algorithms & Strategy",
    team: "Team & Agency", settings: "Settings",
    hello: "Hello", quickActions: "Quick actions",
    save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", add: "Add",
    search: "Search", notifications: "Notifications", profile: "Profile", logout: "Logout",
    appearance: "Appearance", language: "Language", integrations: "Integrations",
    account: "Account & Workspace",
  },
  es: {
    dashboard: "Panel", crm: "CRM Social", contacts: "Contactos & Leads",
    pipeline: "Pipeline", segments: "Segmentos", accounts: "Cuentas & Instagram",
    strategy: "Estrategia & Contenido", analytics: "Analytics & Rendimiento",
    operations: "Operaciones", growth: "Crecimiento", algorithms: "Algoritmos & Estrategia",
    team: "Equipo & Agencia", settings: "Ajustes",
    hello: "Hola", quickActions: "Acciones rápidas",
    save: "Guardar", cancel: "Cancelar", delete: "Eliminar", edit: "Editar", add: "Añadir",
    search: "Buscar", notifications: "Notificaciones", profile: "Perfil", logout: "Salir",
    appearance: "Apariencia", language: "Idioma", integrations: "Integraciones",
    account: "Cuenta & Workspace",
  },
};

const FLAGS = { fr: "🇫🇷", en: "🇬🇧", es: "🇪🇸" };

export function I18nProvider({ children, lang }) {
  const [currentLang, setCurrentLang] = useState(lang || "fr");
  useEffect(() => { setCurrentLang(lang || "fr"); }, [lang]);
  const t = useCallback((key) => DICT[currentLang]?.[key] || DICT.fr[key] || key, [currentLang]);
  return (
    <I18nContext.Provider value={{ t, lang: currentLang, FLAGS }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
